import { observable, action, flow, toJS } from "mobx";
import { getStrategy, saveStrategy } from "services/strategies";
import { delay } from "services/api";
import { message } from "antd";
import joint from "rappid";
import _ from "lodash";

class StrategyStore {
	constructor() {
		this.ui = this.getUI();
	}

	// @observable
	// name = "";

	// @observable
	// id = "";

	@observable
	strategy = {
		id: null,
		name: null		
	};

	@observable
	stateForm = {
		projects: {}
	};

	@observable
	profileNameDataSource = [];

	getUI = () => {
		let ui = {
			loadingStrategy: true,
			savingStrategy: false,
			inspectorVisible: false,
			projectId: null
		};
		return observable.object(ui);
	};

	createProfileNameDataSource = (changedProfileName) => {
		let dataSourceSet = new Set();
		Object.keys(this.stateForm.projects).forEach((key) => {
			let project = this.stateForm.projects[key];
			if (project.profileName.value) {
				dataSourceSet.add(project.profileName.value);
			}			
		});		
		if (changedProfileName) {
			dataSourceSet.delete(changedProfileName);
		}		

		let dataSource = [];

		if (changedProfileName) {
			dataSource.push(changedProfileName);
		}
		
		for (let item of dataSourceSet.entries()) {					
			dataSource.push(item[1]);
		}
		
		return dataSource;
	}

	removeProject = projectId => {
		delete this.strategy.projects[projectId];
		delete this.stateForm.projects[projectId];			
	};

	@action
	formChanged = fields => {
		let customizer = (objValue, srcValue, key, object, source, stack) => {
			if (srcValue == undefined && !_.isArray(source)) {
				return null;
			}
			if (key === "value" && _.isArray(srcValue)) {
				return observable.array(srcValue);
			}
		};				
		_.mergeWith(this.stateForm, fields, customizer);
		let changedProfileName = null;

		if (fields.projects && Object.keys(fields.projects).length > 0) {
			let changedProject = fields.projects[Object.keys(fields.projects)[0]]
			if (changedProject.profileName && changedProject.profileName.value) {
				changedProfileName = changedProject.profileName.value;
			}
		}
		this.profileNameDataSource = this.createProfileNameDataSource(changedProfileName);
	};

	createFormObject = projects => {
		function customizer(value, key, object, stack) {
			if (!_.isObject(value) && key !== "value") {
				return {
					value: value
				};
			}
			if (_.isArray(value) && key != "content" && key != "projects") {
				return _.cloneDeep(value);
			}
		}

		let newObj = _.cloneDeepWith(toJS(projects), customizer);
		return newObj;
	};

	@action
	showInspector(model) {
		this.ui.inspectorVisible = true;
		this.ui.projectId = model.id;
	}

	@action
	hideInspector() {
		this.ui.inspectorVisible = false;
	}

	projectProfileNameChanged = (projectId, profileName) => {};

	//payload is: {svg: svg, diagram: diagram}
	saveDiagram = flow(function*(payload) {
		const { svg, diagram, description } = payload;
		// console.log("Description is", description);
		this.strategy.description = description;
		this.ui.savingStrategy = true;
		// this.strategy = { ...this.strategy, strategy: JSON.stringify(diagram) };
		yield delay(500);
		this.ui.savingStrategy = false;

		// console.log(this.strategy);

		const response = yield saveStrategy({
			id: this.strategy.id,
			name: this.strategy.name,
			description: description,
			img: svg,
			strategy: JSON.stringify(diagram)
		});
		if (response == null) {
			message.error("Failed to save the diagram");
			return;
		}

		if (response.error) {
			message.error("Failed to save the diagram. " + response.error.message);
			return;
		}

		// console.log(response);

		message.success("Successfully saved the diagram");
	});

	loadStrategy = flow(function*(strategyId) {
		// console.log("Loading Strategy");
		this.ui.loadingStrategy = true;
		const response = yield getStrategy(strategyId);
		if (response == null) {
			message.error("Failed to load the diagram");
			return;
		}

		if (response.error) {
			message.error(response.error.message);
			return;
		}

		// console.log("Done loading Strategy");

		this.ui.loadingStrategy = false;

		this.ui.loadingStrategy = false;
		this.strategy = response.strategy;
		if (this.strategy.strategy == null) {
			this.strategy.strategy =
				'{"cells":[{"type":"rankerx.MoneySite","position":{"x":310,"y":100},"size":{"width":90,"height":54},"angle":0,"id":"moneySite","z":1,"attrs":{"custom":{"projectName":"Money Site"}}}]}';
		}

		const graph = new joint.dia.Graph();
		graph.fromJSON(JSON.parse(this.strategy.strategy));

		const elements = graph.getElements();
		let projects = {};

		for (let i = 0; i < elements.length; i++) {
			const element = elements[i];
			const profileName = element.attr("custom/profileName");
			element.attr("bodyText/text", profileName);
			const projectName = element.attr("custom/projectName");
			element.attr("headerText/text", projectName);			
			projects[element.id] = {
				profileName: profileName
			};			
		}

		this.strategy.projects = projects;
		this.strategy.strategy = JSON.stringify(graph.toJSON());

		this.stateForm = this.createFormObject(this.strategy);
		this.profileNameDataSource = this.createProfileNameDataSource();		
	});
}

export default StrategyStore;
